import { escapeForCSV } from '../../../core/utils/download.js';
import { sanitizeAndParseData } from '../../core/utils/sanitize-and-parse-data.js';
import type { TreeMapCSVEntry } from '../types/internal.js';

export function formatCSV(data: TreeMapCSVEntry[]) {
  const columns = ['name', 'value', 'parent'];

  let csv = `${columns.join(',')}\n`;

  for (const node of data) {
    const sanitizedName = escapeForCSV(node.name);
    const sanitizedValue = sanitizeAndParseData(node.value);
    const sanitizedParent = escapeForCSV(node.parent);
    csv += `${sanitizedName},${sanitizedValue},${sanitizedParent}`;
    csv += '\n';
  }

  return csv;
}
